export default {
  init() {
	
  },
  finalize() {
    window.Am2AjaxFunctions.am2_add_to_shortlist();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/singleCourses.js